<template>
    <section>
        <img v-if="loading" class="image page-loading" src="@/assets/img/page-loading.gif" />
        <div v-if="loading === false" class="mb-6">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <h1 class="mb-5">Hey {{ user.firstname }}!</h1>
                        <form>
                            <div class="form-wrapper">
                                <div class="form-row half">
                                    <div class="form-group mb-4">
                                        <input v-bind:value="user.firstname" type="text" placeholder="Firstname" class="form-control" disabled />
                                    </div>
                                    <div class="form-group mb-4">
                                        <input v-bind:value="user.lastname" type="text" placeholder="Lastname" class="form-control" disabled />
                                    </div>
                                </div>
                                <div class="form-row half">
                                    <div class="form-group mb-4">
                                        <input v-bind:value="user.email" type="text" placeholder="Email" class="form-control" disabled />
                                    </div>
                                    <div class="form-group mb-4">
                                        <input v-bind:value="user.phone" type="text" placeholder="Phone" class="form-control" disabled />
                                    </div>
                                </div>
                                <div class="form-row half">
                                    <div class="form-group mb-4">
                                        <input v-bind:value="user.company" type="text" placeholder="Company" class="form-control" disabled />
                                    </div>
                                    <div class="form-group mb-4">
                                        <input v-bind:value="user.website" type="text" placeholder="Website" class="form-control" disabled />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'AccountMyAccount',
        metaInfo: {
            title: 'My account'
        },
        data () {
            return {
                loading: false,
                user: {
                    firstname: null,
                    lastname: null,
                    email: null,
                    phone: null,
                    company: null,
                    website: null
                }
            }
        },
        mounted () {
            this.load_user();
        },
        methods: {
            load_user () {
                this.loading = true;
                axios.get(process.env.VUE_APP_API_URL + '/api/user/')
                    .then(response => (
                        this.user.firstname = response.data['firstname'],
                        this.user.lastname = response.data['lastname'],
                        this.user.email = response.data['email'],
                        this.user.phone = response.data['phone'],
                        this.user.company = response.data['company'],
                        this.user.website = response.data['website'],
                        this.loading = false
                    ))
            },
        }
    }
</script>